import { reactive, inject, computed, provide } from '@vue/composition-api'
import { getCurrentUser } from '@/shared/api'
import { User } from '@/shared/types'
import { roles, accessList } from '@/shared/user/roles'

const stateSymbol = Symbol('user-state')

interface StateType {
  user: User
  loading: boolean
}

const initialState: StateType = {
  user: null as User,
  loading: false,
}

const createStore = () => {
  const state = reactive<StateType>({ ...initialState })

  const getters = {
    user: computed(() => state.user),
    loading: computed(() => state.loading),
    hasPermissionTo: computed(
      () => (action: keyof typeof accessList): boolean => {
        if (!accessList[action]) {
          console.error(`action ${action} not included in accessList`)
          return false
        }
        return state.user
          ? accessList[action].includes(roles[state.user.role])
          : false
      }
    ),
  }

  const actions = {
    fetchUser: async () => {
      try {
        state.loading = true
        state.user = await getCurrentUser()
        state.loading = false
      } catch (e) {
        state.loading = false
        throw e
      }
    },
  }

  return {
    state: computed(() => state),
    getters,
    actions,
  }
}

export const provideStore = () => provide(stateSymbol, createStore())
export const useStore = () =>
  inject(stateSymbol) as ReturnType<typeof createStore>
